import Image from 'next/image'

import { Badge } from '@wartek-id/badge'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

import CardPeriod from 'app/KinerjaShared/components/CardPeriod'
import { formatDate, isDateValid } from 'utils/datetime'

type BannerPelaksanaanNotStartedProps = {
  periodNo: number
  pelaksanaanDate: string
}
export function BannerPelaksanaanNotStarted({
  periodNo,
  pelaksanaanDate,
}: BannerPelaksanaanNotStartedProps) {
  let pelaksanaanMonth: string

  if (isDateValid(pelaksanaanDate)) {
    pelaksanaanMonth = formatDate(pelaksanaanDate, 'MMMM yyyy')
  } else {
    pelaksanaanMonth = periodNo === 1 ? 'Februari' : 'Agustus'
  }

  return (
    <Card>
      <div className="flex gap-6 p-6">
        <div className="flex flex-col">
          <Image
            alt=""
            src="/illustrations/img-time-document.png"
            width={84}
            height={84}
          />
        </div>
        <div className="flex-1 flex flex-col gap-1 justify-center">
          <Text
            variant="subheading"
            color="informational"
            className="!text-blue-60 !uppercase tracking-[0.5px]"
          >
            <CardPeriod period={periodNo} />
          </Text>

          <div className="flex items-center gap-2">
            <Text variant="heading-lg">
              Menunggu periode Pelaksanaan Kinerja
            </Text>
            <Badge className="uppercase">Khusus Kepala Sekolah</Badge>
          </div>
          <Text color="subdued" className="max-w-3xl">
            Perencanaan guru sudah selesai dan disetujui. Anda dapat lanjut ke
            Pelaksanaan mulai dari <strong>{pelaksanaanMonth}</strong>. Cek lagi
            halaman ini nanti, ya.
          </Text>
        </div>
      </div>
    </Card>
  )
}
